import { ControlePH } from "./controle-pH"
import { EpH } from "./enum/pH"

export class AjustagePH {
    Code: string

    // Type: EpH
    NumeroLot: string
    Pente: number = null
    Decalage: number = null

    ControlePh: ControlePH = new ControlePH()

    get Conforme() {
        if (this.Pente === null || this.Decalage === null)
            return false

        return this.NumeroLot !== this.ControlePh.ControleNumeroLot &&
            this.Pente >= -66 && this.Pente <= -56 && this.Decalage >= -12 && this.Decalage <= 12 && this.ControlePh.Conforme;
    }

    toJSON() {
        let ms: any = Object.assign({}, this)
        ms.Conforme = this.Conforme;
        return ms;
    }

    static mapFromJSON(json: any): AjustagePH {
        const ms = new AjustagePH();

        ms.Code = json.code;
        // ms.Type = json.type;
        ms.NumeroLot = json.numeroLot;
        ms.Pente = json.pente;
        ms.Decalage = json.decalage;

        if (json.controlePh) {
            ms.ControlePh = ControlePH.mapFromJSON(json.controlePh)
        }
        return ms;
    }
}